<template>
  <div class="rtl">
    <m-form
      title="ویرایش بسته و ما‌به‌تفاوت"
      :isEditing.sync="isEditing"
      :showList="false"
      :show-submit-and-clear-btn="true"
      :show-navigation-btns="false"
      :show-list-btn="false"
      :can-delete="false"
      @submit="submit"
    >
      <template #default>
        <v-row>
          
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="form.company_id"
              label="ID کسب و کار"
              type="number"
              outlined
              required
            />
          </v-col>
          
          <v-col cols="12" md="6">
            <date label="تاریخ شروع" v-model="form.start_at" :default="false" :clearable="true" type="date" />
          </v-col>
          
          <v-col cols="12" md="6">
            <date label="تاریخ پایان" v-model="form.expire_at" :default="false" :clearable="true" type="date" />
          </v-col>
          
          <v-col cols="12" sm="6">
            <money
              v-model="form.amount"
              label="مبلغ ما‌به‌تفاوت"
              outlined
              required
            />
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>

<script>
import { MFormMixin } from "@/components/m-form";
import Date from "@/components/mcomponents/cleave/Date.vue";

export default {
  mixins: [MFormMixin],
  components: [Date],
  data() {
    return {
      baseUrl: "sobhanAdmin/companies/adjust-extension/",
      appendSlash: true,
      hasList: false,
      hasIdProp: false,
      isEditing: true,
      startMenu: false,
      endMenu: false,
      form: {
        company_id: null,
        start_at: null,
        expire_at: null,
        amount: null,
      },
    };
  },
  methods: {
    getSerialized() {
      return this.form;
    },
    submit() {
      this.request({
        url: this.endpoint(this.baseUrl),
        method: "post",
        data: this.getSerialized(),
        success: (data) => {
          this.notify('عملیات با موفقیت انجام شد.', 'success');
          this.form = {
            company_id: null,
            start_at: null,
            expire_at: null,
            amount: null,
          };
        },
      });
    },
  },
};
</script>
